( function () {
	'use strict';

	/* eslint no-use-before-define:0 */

	/* @ngInject */
	function evidenceEditModal () {
		return {
			'templateUrl'  : '/templates/components/evidences/pool/evidence-edit-modal.html',
			'controller'   : 'EvidenceEditModalCtrl',
			'controllerAs' : 'vm',
			'scope'        : {
				'evidence'          : '=',
				'pool'              : '=',
				'attached'          : '=',
				'deleteModal'       : '&',
				'deleteEvidence'    : '&',
				'level'             : '=',
				'innerLevel'        : '=',
				'observation'       : '=',
				'updateScope'       : '&',
				'isSplit'           : '=',
				'isObsLevel'        : '=',
				'index'             : '=',
				'hasAllEvidences'   : '=',
				'identifier'        : '=',
				'isTemplatePreview' : '='
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'evidenceEditModal', evidenceEditModal );
} )( );
